<template>
    <div class="payDalog">
      <el-dialog  :visible.sync="payDalog" width="573px"  :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="contentElDialog">
                <div class="title">
                    <div class="text">确认支付</div>
                    <img class="tanx" src="../components/images/tanx.png" alt="" @click="closeDialog()">
                </div>
                <div class="formContent">
                    <div class="list">
                        <div class="lable">订单类型：</div>
                        <div class="text">版权登记</div>
                    </div>
                    <div class="list boderDashed">
                        <div class="lable">办理时长：</div>
                        <div class="timeBox">
                            <div class="item " :class="tiemBoxIdx == index?'active':''" v-for="(item,index) in zhouqi" :key="index" @click="zhouqiData(item,index)">{{item.text}}</div>
                        </div>
                    </div>
                    <div class="list boderDashedM">
                        <div class="lable">订单金额：</div>
                        <div class="money">¥{{(payMoney.bizPrice / 100).toFixed(2)}}</div>
                    </div>
                </div>
								<div class="btnBox">
									<div class="cz" @click="closeDialog()">取消</div>
									<div class="cxybz" v-if="payMoney.bizPrice > 0" @click="updateUrgentInfo()">去支付</div>
									<div class="cxybz" v-else @click="updateUrgentInfo2()">确认</div>
								</div>
            </div>
      </el-dialog>
    </div>
</template>

<script>
		import {getPayInfoByOrderSeqNo,getPayStatusByOrderSeqNo,configGetBzPrice,updateUrgentInfo} from "@/api/index.js";
import { isThisHour } from 'date-fns';
		
    export default {
        name: "payDalog",
        props: {
           
        },
        components: {
        },
        data() {
            return {
							zhouqi: [
									{
											name: '标准',
											text: '5-7工作日出证',
											code: '020303',
											state: 1
									},
									{
											name: '加急办理',
											text: '3工作日出证',
											code: '020302',
											state: 2
									},
									{
											name: '加急办理',
											text: '1工作日出证',
											code: '020301',
											state: 2
									}
							],
              zhouqiShengNei: [
                {
                  name: '标准',
                  text: '5-7工作日出证',
                  code: '020306',
                  state: 1
                },
                {
                  name: '加急办理',
                  text: '3工作日出证',
                  code: '020305',
                  state: 2
                },
                {
                  name: '加急办理',
                  text: '1工作日出证',
                  code: '020304',
                  state: 2
                }
              ],
              payBoxIdex: 0,
							tiemBoxIdx: 0,
							payDalog: false,
							payCode: '',
							payWay: 'AliPay',
							payMoney: 0,
							payOrder: {
								orderSeqNo: ''
							},
							payWayList: [
								{
									name: '支付宝支付',
									payWay: 'AliPay',
									img: require('../assets/alipay.png')
								},
								{
									name: '微信支付',
									payWay: 'WechatPay',
									img: require('../assets/wxpay.png')
								}
							],
							orderType: '',
							setTime: null,
							bizTypeBy: '',
							subBizTypeBy: '',
							orderData: {},
							payMoney: {
								bizPrice: 0
							},
							urgentDayType: '020303',
							operationType: 1,
							obligees: [],
            }
        },
        computed: {
        },
        watch: {
            $route(to, from) {
            }
        },
        mounted() {
					
        },
				destroyed () {
					clearInterval(this.setTime)
				},
        methods: {
					// 获取金额
            async configGetBzPrice(order,obligeesData) {
								let that = this
								this.orderData = order
								this.obligees = obligeesData

								this.payDalog = true
								if (this.obligees.length > 0) {
                    for(let i in that.obligees) {
												if (that.obligees[i].identityType == 1) {
                                if (that.obligees[i].identityNo.substring(0,2) == 62) {//省内
                                  if (this.operationType == 1) {//标准
                                    this.payMoney.bizPrice = 0
                                    this.urgentDayType = this.zhouqiShengNei[0].code
                                    console.log(this.zhouqiShengNei[0].code)
                                  } else {//加急
                                    this.urgentDayType = this.zhouqiShengNei[this.tiemBoxIdx].code
                                  }
                                }
                                  let data2 = {
                                    bizType: '02', // 登记
                                    subBizType: this.urgentDayType
                                  }
                                  let res2 = await configGetBzPrice(data2)
                                  this.payMoney = res2.result

                            } else if (that.obligees[i].identityType == 4) {
                                if (that.obligees[i].identityNo.substring(2,4) == 62) {//省内
                                  if (this.operationType == 1) {//标准
                                    this.payMoney.bizPrice = 0
                                    this.urgentDayType = this.zhouqiShengNei[0].code
                                  } else {//加急
                                    this.urgentDayType = this.zhouqiShengNei[this.tiemBoxIdx].code
                                  }
                                }

                              let data3 = {
                                bizType: '02', // 登记
                                subBizType: this.urgentDayType
                              }
                              let res3 = await configGetBzPrice(data3)
                              this.payMoney = res3.result
                            }
                    }
                } else {
                  let data1 = {
                    bizType: '02', // 登记
                    subBizType: this.urgentDayType
                  }
                  let res1 = await configGetBzPrice(data1)
                    this.payMoney = res1.result
                }  
                
            },
						zhouqiData(item,index) {
							this.tiemBoxIdx = index
							this.urgentDayType = item.code
              this.operationType = item.state
							this.configGetBzPrice(this.orderData,this.obligees)
						},
            closeDialog() {
              this.payDalog = !this.payDalog 
            },
						confirm() {
							this.closeDialog()
              this.$emit('confirm',this.dataObj)
            },
						updateUrgentInfo() {
								let that = this
								let dataPost = {
										orderSeqNo: that.orderData,
										urgentDayType: that.urgentDayType,
										operationType: that.operationType
								}
								updateUrgentInfo(dataPost).then( res => {
										this.closeDialog()
              			this.$emit('confirm3up',dataPost)
								})
						},
						updateUrgentInfo2() {
								let that = this
								let dataPost = {
										orderSeqNo: that.orderData,
										urgentDayType: that.urgentDayType,
										operationType: that.operationType
								}
								updateUrgentInfo(dataPost).then( res => {
										this.closeDialog()
              			this.$emit('confirm3up2',dataPost)
								})
						},
        },
        beforeDestroy() {}
    };
</script>

<style lang="less" scoped>
.contentElDialog{
	background: #fff;
	.title{
			display: flex;
			align-items: center;
			height: 66px;
			border-bottom: solid 1px #E5E5E5;
			padding: 0 26px;
			.text{
					font-size: 16px;
					font-weight: 700;
					color: #333;
			}
			.tanx{
					width: 14px;
					height: 14px;
					margin-left: auto;
					cursor: pointer;
			}
	}
	.formContent{
		padding: 33px;
		
		.list{
			display: flex;
			align-items: center;
			padding-bottom: 16px;
			.lable{
				font-size: 14px;
				color: #999999;
				margin-right: 24px;
			}
			.text{
				flex: 1;
			}
			.timeBox{
				display: flex;
				align-items: center;
				.item{
					color: #666666;
					border: solid 1px #E5E5E5;
					border-radius:4px;
					font-size: 14px;
					padding: 9px 14px;
					margin-right: 12px;
					cursor: pointer;
					&:last-child{
						margin-right: 0;
					}
				}
				.active{
					color: #2196F3;
					border: solid 1px #2196F3;
					background-color: rgba(32, 150, 243, 0.1);
				}
			}
			.money{
				font-size: 26px;
				font-weight: 700;
				color: #FF2121;
			}
			.payBox{
				display: flex;
				align-items: center;
				.item{
					display: flex;
					align-items: center;
					border: solid 1px #E5E5E5;
					padding: 8px 46px;
					margin-right: 19px;
					border-radius:4px;
					cursor: pointer;
					&:last-child{
						margin-right: 0;
					}
					.iocn{
						width: 32px;
						height: 32px;
            margin-right: 5px;
					}
				}
				.active{
					color: #2196F3;
					border: solid 1px #2196F3;
					background-color: rgba(32, 150, 243, 0.1);
				}
			}
		}
		.boderDashedP{
			padding: 20px 0;
		}
		.boderDashedM{
			border-bottom: dashed 1px #E5E5E5;
			padding: 15px 0;
		}
		.boderDashed{
			border-bottom: dashed 1px #E5E5E5;
			padding-bottom: 32px;
		}
	}
	.payCode{
		padding-bottom: 44px;
		.code{
			width: 206px;
			height: 206px;
			margin: auto;
		}
	}
}
.btnBox{
		display: flex;
		align-items: center;
		justify-content: center;
		padding-bottom: 50px;
		.cz{
				font-size: 14px;
				color: #999999;
				text-align: center;
				width: 170px;
				height: 40px;
				line-height: 40px;
				border-radius: 4px;
				border: 1px solid #E5E5E5;
				margin: 0 10px;
				text-align: center;
				cursor: pointer;
		}
		.cxybz{
				width: 170px;
				height: 40px;
				background: #2196F3;
				line-height: 40px;
				border-radius: 4px;
				margin: 0 10px;
				color: #fff;
				text-align: center;
				cursor: pointer;
		}
	}
.payDalog{
    /deep/ .el-dialog{
        border-radius: 16px;
        overflow: hidden;
        position: absolute;
        margin: auto !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    /deep/ .el-dialog__body{
        padding: 0;
    }
    /deep/ .el-dialog__header{
        padding: 0;
    }
}
</style>
